import React, { useState } from "react";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { Star } from "@mui/icons-material";
import { colors } from "../../utils/color";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import GradeIcon from "@mui/icons-material/Grade";
import { Modal, Button } from "antd";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import { handleRating } from "../../utils/helper";
import { firestore } from "../../config/firebase";
import { collection, deleteDoc, doc, setDoc } from "@firebase/firestore";
const production = true;
export const base_url = production
  ? "https://us-central1-connect-overseas-visa-in-59937.cloudfunctions.net/api/api"
  : "http://localhost:3001/api";
export default function UserReviews(props) {
  const { reviews } = props;

  const [feedbackModal, setFeedbackModal] = useState(false);
  const [feedbackComment, setFeebackComment] = useState("");
  const [star, setStar] = useState(5);
  const [rating, setRating] = useState([
    {
      id: 1,
      star: false,
    },
    {
      id: 2,
      star: false,
    },
    {
      id: 3,
      star: false,
    },
    {
      id: 4,
      star: false,
    },
    {
      id: 5,
      star: false,
    },
  ]);
  const [userName, setUserName] = useState("");
  const [deleteModal, setDeleteModal] = useState({ delete: false, item: "" });
  const location = useLocation();
  const selectedUser = location.state?.selectedUser || null;
  const navigate = useNavigate();

  const reset_state = () => {
    setFeebackComment("");
    setStar(5);
    setRating([
      ...rating.map((el) => {
        el.star = false;
        return el;
      }),
    ]);
  };

  const getRatingFromAdmin = (index) => {
    setStar(index + 1);
    const newRating = rating.map((el, i) => {
      if (i <= index) {
        return { ...el, star: true };
      } else {
        return { ...el, star: false };
      }
    });
    setRating(newRating);
  };

  const addFeeback = async () => {
    if (rating.every((el) => !el.star)) {
      return;
    }
    try {
      const newData = {
        counsellor_uuid: selectedUser?.uuid || "",
        user_name: userName || "Jaspreet Singh",
        star: star,
        user_image:
          "https://banner2.cleanpng.com/20230919/cib/transparent-world-mental-health-day-1711072726465.webp",
        counsellor_name: selectedUser?.firstName + " " + selectedUser?.lastName,
        comment: feedbackComment,
        date: Date.now(),
        counsellor_image: selectedUser?.image,
        user_uuid: "gbfh88494nndskjs099d",
        review_type: 2,
      };

      const feedbackRef = doc(
        collection(
          firestore,
          "user_feedback",
          selectedUser?.uuid,
          selectedUser?.uuid
        )
      );
      const counsellorRef = doc(firestore, "feedback_list", feedbackRef.id);
      await setDoc(feedbackRef, newData);
      await setDoc(counsellorRef, newData);

      let data = {
        star: star,
        counsellor_number: selectedUser?.phone,
      };

      axios
        .post(base_url + "/admin-feedback/", data)
        .then((res) => {
          navigate("/counsellorlist");
          reset_state();
        })
        .catch((err) => {});
      setFeedbackModal(false);
    } catch (err) {
      alert("Erorr occured! Try again");
      setFeedbackModal(false);
    }
  };

  const delete_feedback = async () => {
    try {
      const feedbackRef = doc(firestore, "feedback_list", deleteModal.item.id);
      const feedbackRef2 = doc(
        firestore,
        "user_feedback",
        selectedUser.uuid,
        selectedUser.uuid,
        deleteModal.item.id
      );
      await deleteDoc(feedbackRef);
      await deleteDoc(feedbackRef2);
      setDeleteModal({ delete: false, item: "" });
      navigate("/counsellorlist");
    } catch (err) {
      setDeleteModal({ delete: true, item: "" });
    }
  };

  return (
    <div>
      <Modal
        title="Confirm Deletion"
        open={deleteModal.delete}
        onOk={delete_feedback}
        onCancel={() => setDeleteModal({ delete: false, item: "" })}
        okText="Yes"
        cancelText="No"
      >
        Are you sure you want to delete this review?
      </Modal>

      <Button onClick={() => setFeedbackModal(true)} className="btn">
        + Add Reviews
      </Button>
      <Modal
        title="Add Reviews"
        open={feedbackModal}
        onCancel={() => setFeedbackModal(false)}
        onOk={() => {
          addFeeback();
        }}
      >
        <div className="feedback-container">
          <div className="feedback-sub-container">
            <div>
              {rating?.map((item, index) => {
                return (
                  <React.Fragment key={item.id}>
                    {item.star ? (
                      <GradeIcon
                        onClick={() => getRatingFromAdmin(index)}
                        style={{ color: "#F9C802", fontSize: 40 }}
                      />
                    ) : (
                      <StarBorderIcon
                        onClick={() => getRatingFromAdmin(index)}
                        style={{ color: "#F9C802", fontSize: 40 }}
                      />
                    )}
                  </React.Fragment>
                );
              })}
            </div>
            <input
              value={userName}
              onChange={(e) => setUserName(e.target.value)}
              placeholder="Enter Name"
            />
            <input
              value={feedbackComment}
              onChange={(e) => setFeebackComment(e.target.value)}
              placeholder="Add comment"
            />
          </div>
        </div>
      </Modal>
      <Grid spacing={2} width={"50%"}>
        {reviews?.map((item, index) => {
          if (index == 0) console.log("item-----", item);
          return (
            <Grid
              xs={10}
              sm={5}
              md={5}
              key={index}
              style={{ position: "relative" }}
            >
              <div
                className="deletion-container"
                onClick={() => setDeleteModal({ delete: true, item: item })}
              >
                <DeleteIcon />
              </div>

              <Card sx={{ display: "flex", margin: 1 }}>
                <CardMedia
                  component="img"
                  image={item.user_image ? item.user_image : "/stu.jpg"}
                  alt="image"
                  sx={{ width: 100, maxHeight: 140 }}
                />

                <CardContent sx={{ flex: "1 0 auto" }}>
                  <Typography component="div" variant="h7">
                    {item.user_name}
                  </Typography>

                  {handleRating(item.star).map((el, i) => {
                    return (
                      <Star
                        style={{
                          color: el.star ? colors.primary : colors.gray,
                        }}
                        fontSize="10"
                      />
                    );
                  })}

                  <Typography
                    variant="subtitle1"
                    color="text.secondary"
                    component="div"
                    sx={{
                      // overflow: "scroll",
                      maxHeight: 80, // Adjust the height as needed
                      fontSize: 12,
                      width: 300,
                    }}
                  >
                    {item.comment}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </div>
  );
}
